import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import styles from "./TestimonialSlider.module.css";
import { gettestimonial } from "../../../Services/APIrequests";
import { FaStar } from "react-icons/fa";
import parse from "html-react-parser";

const TestimonialSlider = ({ id }) => {
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const response = await gettestimonial();
        const data = response?.data?.testimonials || [];
        const activeTestimonials = data.filter(
          (testimonial) => testimonial.status === "ACTIVE"
        );
        setTestimonials(activeTestimonials);
      } catch (err) {
        console.error("Failed to fetch testimonials", err);
      }
    };

    fetchTestimonials();
  }, []);

  const getSliderSettings = () => {
    const count = testimonials.length;

    return {
      dots: true,
      infinite: count > 3,
      speed: 500,
      slidesToShow: Math.min(3, count),
      slidesToScroll: 1,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 4000,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: Math.min(2, count),
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    };
  };

  return (
    <div className={styles.container} id={id}>
      <h2 className={styles.title}>What Our <span style={{ color: "var(--PrimaryColor)" }}>Clients Say</span></h2>
      <p className={styles.subtitle}>Real feedback from businesses we've helped</p>

      {testimonials.length > 0 ? (
        <div className={styles.sliderWrapper}>
          <Slider {...getSliderSettings()}>
            {testimonials.map((testimonial) => (
              <div key={testimonial.id}>
                <div className={styles.card}>
                  <div className={styles.stars}>
                    {[...Array(5)].map((_, i) => (
                      <FaStar key={i} />
                    ))}
                  </div>

                  <div className={styles.quote}>
                    {typeof testimonial.description === "string"
                      ? parse(testimonial.description)
                      : testimonial.description}
                  </div>

                  <div className={styles.separator}></div>

                  <div className={styles.clientInfo}>
                    <span className={styles.clientName}>{testimonial.name}</span>
                    {/* Assuming role/company might be in another field or just using dummy for now as per design */}
                    {testimonial.company && (
                      <span className={styles.clientRole}>
                        {testimonial.company}
                      </span>
                    )}
                    {!testimonial.company && (
                      <span className={styles.clientRole}>Client</span>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      ) : (
        <p>No testimonials available.</p>
      )}
    </div>
  );
};

export default TestimonialSlider;
